/***********************************************
* LandingPage.js
* 
* Show a landingpage
***********************************************/
/* Layout files */
import '../assets/style/LandingPage.css';

/* Global imports */
import React   from 'react';
import { getAppUrl } from '../App';
import { withTranslation } from 'react-i18next';

class LandingPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = { };
    }

    render() {

        return (
            <div className="fullMarkdownPage">
                <div className="loginMarkdownDiv">
                    <select name="language" id="language" className="languageSelect" value={this.props.language.active} onChange={(e) => this.props.language.set(e.target.value)}>
                        {this.props.language.list.map((lang) => <option key={lang} value={lang}>{lang}</option>)}
                    </select>
                    <a href={getAppUrl()} className="button bigButton">Login</a>
                </div>
                <div className='contentPage'>
                    <div className='intro'>
                        <h3>{this.props.t('intro.title')}</h3>
                        <p>{this.props.t('intro.welcome')}</p>
                        <p>{this.props.t('intro.subtitle')}</p>
                    </div>
                    <div className='textBlock'>
                        <h4>{this.props.t('section.introduction.title')}</h4>
                        <div className='video'>
                            <iframe width="800" height="450" allow="fullscreen;" frameborder="0" 
                                src="https://www.youtube.com/embed/OtqOiqT3Inw?autoplay=1&mute=1&rel=0&color=white"
                            />
                        </div>
                        <hr />
                    </div>
                    <div className='textBlock flexContainer'>
                        <h4>{this.props.t('section.why.title')}</h4>
                        <div className="break"></div>
                        <div className='img'>
                            <img src="../background.jpg" alt={this.props.t('logos.accurateModelAlt', 'Accurate model')} />
                        </div>
                        <div className='text'>
                            <p><strong>{this.props.t('why.heading.captureReality')}</strong></p>
                            <ul>
                                <li><strong>{this.props.t('why.advancedPhotogrammetry.label')}:</strong>{' '}{this.props.t('why.advancedPhotogrammetry.text')}</li>
                                <li><strong>{this.props.t('why.userFriendly.label')}:</strong>{' '}{this.props.t('why.userFriendly.text')}</li>
                                <li><strong>{this.props.t('why.comprehensiveTools.label')}:</strong>{' '}{this.props.t('why.comprehensiveTools.text')}</li>
                            </ul>
                            <p><strong>{this.props.t('why.heading.efficiencyAccuracy')}</strong></p>
                            <ul>
                                <li><strong>{this.props.t('why.saveTime.label')}:</strong>{' '}{this.props.t('why.saveTime.text')}</li>
                                <li><strong>{this.props.t('why.enhanceAccuracy.label')}:</strong>{' '}{this.props.t('why.enhanceAccuracy.text')}</li>
                            </ul>
                        </div>
                        <hr />
                    </div>
                    <div className='textBlock'>
                        <h4>{this.props.t('section.features.title')}</h4>
                        <p><strong>{this.props.t('features.heading.intuitiveWorkflow')}</strong></p>
                        <ul>
                            <li><strong>{this.props.t('features.easyUpload.label')}:</strong>{' '}{this.props.t('features.easyUpload.text')}</li>
                            <li><strong>{this.props.t('features.automatedProcessing.label')}:</strong>{' '}{this.props.t('features.automatedProcessing.text')}</li>
                            <li><strong>{this.props.t('features.customizationOptions.label')}:</strong>{' '}{this.props.t('features.customizationOptions.text')}</li>
                        </ul>
                        <p><strong>{this.props.t('features.heading.highQualityOutputs')}</strong></p>
                        <ul>
                            <li><strong>{this.props.t('features.detailedMeshes.label')}:</strong>{' '}{this.props.t('features.detailedMeshes.text')}</li>
                            <li><strong>{this.props.t('features.accurateTexturing.label')}:</strong>{' '}{this.props.t('features.accurateTexturing.text')}</li>
                            <li><strong>{this.props.t('features.scalability.label')}:</strong>{' '}{this.props.t('features.scalability.text')}</li>
                        </ul>
                        <p><strong>{this.props.t('features.heading.integrationExport')}</strong></p>
                        <ul>
                            <li><strong>{this.props.t('features.compatibility.label')}:</strong>{' '}{this.props.t('features.compatibility.text')}</li>
                            <li><strong>{this.props.t('features.cloudStorage.label')}:</strong>{' '}{this.props.t('features.cloudStorage.text')}</li>
                        </ul>
                        <div className='logo'>
                            <img src="../logos/SketchUp-logo.png" alt={this.props.t('logos.sketchup.alt')} />
                        </div>
                        <div className='logo'>
                            <img src="../logos/recap-logo.png" alt={this.props.t('logos.recap.alt')} />
                        </div>
                        <div className='logo'>
                            <img src="../logos/autocad-logo.png" alt={this.props.t('logos.autocad.alt')} />
                        </div>
                        <div className='logo'>
                            <img src="../logos/rhinoceros-3d-logo.png" alt={this.props.t('logos.rhino.alt')} />
                        </div>
                        <div className='logo'>
                            <img src="../logos/revit-logo.jpg" alt={this.props.t('logos.revit.alt')} />
                        </div>
                        <hr />
                    </div>
                    <div className='textBlock'>
                        <h4>{this.props.t('section.howItWorks.title')}</h4>
                        <ol>
                            <li><strong>{this.props.t('how.step1.title')}:</strong>{' '}{this.props.t('how.step1.text')}</li>
                            <li><strong>{this.props.t('how.step2.title')}:</strong>{' '}{this.props.t('how.step2.text')}</li>
                            <li><strong>{this.props.t('how.step3.title')}:</strong>{' '}{this.props.t('how.step3.text')}</li>
                            <li><strong>{this.props.t('how.step4.title')}:</strong>{' '}{this.props.t('how.step4.text')}</li>
                            <li><strong>{this.props.t('how.step5.title')}:</strong>{' '}{this.props.t('how.step5.text')}</li>
                        </ol>
                        <hr />
                    </div>
                    <div className='textBlock'>
                        <h4>{this.props.t('section.successStories.title')}</h4>
                        <p><em>{this.props.t('testimonial.1.text')}</em> - <strong>{this.props.t('testimonial.1.author')}</strong></p>
                        <p><em>{this.props.t('testimonial.2.text')}</em> - <strong>{this.props.t('testimonial.2.author')}</strong></p>
                        <hr />
                    </div>
                    <div className='textBlock buttonLinks'>
                        <h4>{this.props.t('section.startToday.title')}</h4>
                        <p>{this.props.t('startToday.text')}</p>
                        <p>
                            <strong><a href={getAppUrl()}>{this.props.t('cta.getStarted')}</a></strong><br />
                            <strong><a href="mailto:photomation@mapix.be">{this.props.t('cta.contactUs')}</a></strong>
                        </p>
                        <hr />
                    </div>
                    <div className='textBlock'>
                        <h4>{this.props.t('section.faq.title')}</h4>
                        <p>
                            <strong>{this.props.t('faq.1.question')}</strong><br />
                            {this.props.t('faq.1.answer')}
                        </p>
                        <p>
                            <strong>{this.props.t('faq.2.question')}</strong><br />
                            {this.props.t('faq.2.answer')}
                        </p>
                        <hr />
                    </div>
                    <div className='textBlock'>
                        <h4>{this.props.t('section.contact.title')}</h4>
                        <p>
                            {this.props.t('contact.moreQuestions')}<br />
                            <strong>{this.props.t('contact.email.label')}:</strong>{' '}
                            <a href="mailto:photomation@mapix.be">{this.props.t('contact.email.address')}</a>
                        </p>
                        <hr />
                    </div>
                    <div className='copyright'>
                        <p><strong>{this.props.t('footer.tagline')}</strong></p>
                        <p><a href="https://mapix.be">{this.props.t('footer.mapix')}</a></p>
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation("Landingpage")(LandingPage);